var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-6 col-md-6 ml-auto mr-auto register-information-page"},[_c('card',{staticClass:"register-information-card",attrs:{"type":"signup"}},[_c('register-information-store')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }